export default __webpack_public_path__ + "static/game-image-4-c4ccf76a326b731e5b4fae112e5d6650.png";